import Vue from 'vue';
import NotificationCollapseHandler from "@/components/alert_components/error/NotificationCollapseHandler.js";

export default {
    namespaced: true,
    state: {
        errors: [],
        isOpen: null
    },
    mutations: {
        setErrors(state, errors) {
            Vue.set(state, 'errors', errors);
            NotificationCollapseHandler.handleTimeout(state.isOpen);
        },
        setIsOpen(state, isOpen) {
            Vue.set(state, 'isOpen', isOpen);
            NotificationCollapseHandler.handleTimeout(state.isOpen);
        },
        resetStore(state) {
            Vue.set(state, 'errors', []);
            Vue.set(state, 'isOpen', null);
            NotificationCollapseHandler.handleTimeout(state.isOpen);
        },
        resetError(state, { fieldName }) {
            state.errors = state.errors.filter(error => error.fieldName !== fieldName);
        }
    },
    actions: {
        setErrors({ commit }, errors = []) {
            commit('setErrors', errors);
        },
        showErrorNotification({ commit },) {
            commit('setIsOpen', true);
        },
        hideErrorNotification({ commit },) {
            commit('setIsOpen', false);
        },
        toggleIsOpen({ state, dispatch }) {
            if (state.isOpen === false) {
                return dispatch('showErrorNotification');
            }
            return dispatch('hideErrorNotification');
        },
        resetStore({ commit }) {
            commit('resetStore');
        },
        resetError({ commit }, error) {
            commit('resetError', error);
        }
    },
    getters: {
        getErrors: state => state.errors,
        getIsOpen: state => state.isOpen
    }
}
